export const getTargetKey = (entry) =>
  typeof entry === 'string' ? entry : entry.key;

export const filterTargetList = (list, availableKeySet) =>
  (list || []).filter((entry) => availableKeySet.has(getTargetKey(entry)));

export const targetListHasKey = (list, key) =>
  (list || []).some((entry) => getTargetKey(entry) === key);

export const removeKeyFromTargetList = (list, key) =>
  (list || []).filter((entry) => getTargetKey(entry) !== key);
